module.exports = __webpack_public_path__ + "img/b3.b7d1bf58.jpg";